export const haveCommonItems = (arr1, arr2) => {
    const set1 = new Set(arr1);
    const commonItems = arr2.filter(item => set1.has(item));

    return commonItems.length > 0;
}

export const generateDate = date => {
    const localDate = new Date(date + " UTC")

    return localDate.toLocaleString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false, minute: '2-digit', second: '2-digit' }).replace(/,/g, "")
}

export const getOrderDetailsPath = ({ vmiIds = [], limit, offset }) => {
    const params = [];

    if (vmiIds[0]) {
        params.push(`vmi=${vmiIds.join(",")}`)
    }

    if (typeof limit === "number") {
        params.push(`limit=${limit}`)
    }

    if (typeof offset === "number") {
        params.push(`offset=${offset}`)
    }

    return `order_zone_details${params.length ? `?${params.join("&")}` : ""}`
}

export const toLower = value => (value || "").toString().toLowerCase()
